import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';

const detailsRowGrid = css`
  display: grid;
  grid-template-columns: 110px 220px 120px 100px minmax(0, 1fr) 150px 150px 240px;
  gap: 16px;
  align-items: center;
`;

// Layout — no horizontal padding so the task rows share the status row's 24px inset
// and their grid columns line up with the cells above
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-top: 1px solid ${colors.neutral20};
  background: ${colors.neutral5};
`;

export const PendingState = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px;
`;

// Failure Banner
export const FailedBlock = styled.div`
  display: flex;
  gap: 10px;
  padding: 14px 16px;
  margin: 0 24px;
  border: 1px solid ${colors.red20};
  border-radius: 8px;
  background: ${colors.red0};
  color: ${colors.red70};

  svg {
    font-size: 18px;
    margin-top: 1px;
  }
`;

export const FailedText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;

  code {
    font-family: monospace;
  }
`;

// Tasks — compact details grid: duration stays near status, while started/ended/artifacts
// are grouped at the right edge.
export const TasksSection = styled.div`
  padding-top: 8px;
`;

export const TasksHeaderRow = styled.div`
  ${detailsRowGrid};
  padding: 10px 24px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${colors.neutral60};
  border-bottom: 1px solid ${colors.neutral20};
`;

export const TaskRow = styled.div`
  ${detailsRowGrid};
  padding: 12px 24px;
  background: ${colors.white};
  border-bottom: 1px solid ${colors.neutral10};
  font-size: 13px;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const TaskKey = styled.code`
  font-family: monospace;
  font-weight: 600;
  font-size: 13px;
`;

// Artifacts — spans the actions + caret zones of the shared grid
export const ArtifactsCell = styled.div`
  grid-column: 8 / -1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ArtifactChip = styled.a<{ disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid ${colors.neutral20};
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  text-decoration: none;
  color: ${({ disabled }) => (disabled ? colors.neutral40 : colors.neutral90)};
  background: ${({ disabled }) => (disabled ? colors.neutral5 : colors.white)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &:hover {
    background: ${colors.neutral5};
  }

  svg {
    font-size: 14px;
  }
`;
